import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { getSchoolsNetworkUrl } from '@/web/containers/Benefits/ChildcareVoucher/utils';
import {
  Box,
  Flex,
  PageHeader,
  themeSprinkles,
} from '@coverflex-tech/hypernova';
import { useRouter } from 'expo-router';

const SchoolsNetwork = () => {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const listenMessage = (message: MessageEvent) => {
      if (message.data === 'request_school') {
        router.push(ROUTES.ADD_SCHOOL);
      }
    };
    if (iframeRef.current) {
      window.addEventListener('message', listenMessage);
    }

    return () => {
      window.removeEventListener('message', listenMessage);
    };
  }, [router]);

  return (
    <Flex flexDirection="column" fullHeight>
      <Box padding="2xl">
        <PageHeader title={t('dashboard.schools_network.title')} />
      </Box>
      <iframe
        frameBorder="0"
        title={t('dashboard.schools_network.title')}
        src={getSchoolsNetworkUrl(i18n.language)}
        className={themeSprinkles({ flexGrow: 1 })}
        ref={iframeRef}
      />
    </Flex>
  );
};

export default SchoolsNetwork;
